import TableTemplate, { ITable } from "../../TableTemplate/tableTemplate";
import {
  IStepOrderTableReport,
  IStepTablesSearchParam,
} from "../../../Interfaces/stepInterfaces";
import StepOrderTableUI from "./StepOrderTableUI";
import { getStepOrderTable } from "../../../Requests/stepRequests";

interface IStepOrderTableProps {
  searchParam: IStepTablesSearchParam;
}

const getDataTable: ITable<
  IStepTablesSearchParam,
  IStepOrderTableReport
>["getDataTable"] = async (
  searchParam,
  offset,
  pageSize,
  sortingType,
  additional,
  axiosOptions,
) => {
  const pausePlayStatusRequestedAt = performance.now();
  const response = await getStepOrderTable(
    searchParam,
    offset,
    pageSize,
    sortingType || "",
    additional,
    axiosOptions,
  );
  return { ...response, pausePlayStatusRequestedAt };
};

const StepOrderTable = ({ searchParam }: IStepOrderTableProps) => {

  return (
    <div className="overflow-auto order-table">
      <TableTemplate<IStepTablesSearchParam, IStepOrderTableReport>
        key={JSON.stringify(searchParam)}
        refreshTableTime={5000}
        getDataTable={getDataTable}
        TableUI={StepOrderTableUI}
        searchParameters={searchParam}
        withSort
        showPageSize
      />
    </div>
  );
};

export default StepOrderTable;
